"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fileTypeSchema = void 0;
const tslib_1 = require("tslib");
const fluent_json_schema_1 = tslib_1.__importDefault(require("fluent-json-schema"));
const FileType_1 = require("../models/FileType");
exports.fileTypeSchema = {
    prop: "type",
    schema: fluent_json_schema_1.default.number().required().enum(Object.values(FileType_1.FileType)),
};
//# sourceMappingURL=fileTypeSchema.js.map